import moment from "moment-jalaali";
import "moment-timezone";

export function utcToLocalTime(time, format = "jYYYY/jM/jD HH:mm:ss") {
  if (!time) {
    return null;
  }
  const utc = moment.utc(time);
  return !moment(time).isSame("0001-01-01 00:00:00")
    ? moment(utc).local().format(format)
    : null;
}

export function utcToTime(time, format = "jYYYY/jM/jD HH:mm:ss") {
  if (!time) {
    return null;
  }
  const utc = moment.utc(time);
  return !moment(time).isSame("0001-01-01 00:00:00")
    ? moment(utc).format(format)
    : null;
}

export const meterToHumanReadableDistance = (dis) => {
  const KM = Math.floor(dis / 1000);
  const M = Math.floor(dis - KM * 1000);

  if (Math.floor(KM) === 0 && Math.floor(M) === 0) {
    return `-`;
  }
  if (KM === 0) {
    return `${M}m`;
  }

  return `${KM}Km ${M}m`;
};

export function utcToHumanReadableTime(time) {
  const houres = Math.floor(time / 3600);
  const minutes = Math.floor(time / 60) - houres * 60;
  const seconds = time - minutes * 60 - houres * 3600;

  if (
    Math.floor(minutes) === 0 &&
    Math.floor(houres) === 0 &&
    Math.floor(seconds) === 0
  ) {
    return `-`;
  }
  if (Math.floor(minutes) === 0 && Math.floor(houres) === 0) {
    return `${Math.floor(seconds)}s`;
  }
  if (houres === 0) {
    return `${Math.floor(minutes)}m ${Math.floor(seconds)}s`;
  }
  return `${Math.floor(houres)}h ${Math.floor(minutes)}m ${Math.floor(
    seconds
  )}s`;
}

export function utcToHumanReadableClockTime(time) {
  const houres = Math.floor(time / 3600);
  const minutes = Math.floor(time / 60) - houres * 60;
  const seconds = time - minutes * 60 - houres * 3600;

  if (
    Math.floor(minutes) === 0 &&
    Math.floor(houres) === 0 &&
    Math.floor(seconds) === 0
  ) {
    return `-`;
  }
  if (Math.floor(minutes) === 0 && Math.floor(houres) === 0) {
    return `${Math.floor(seconds)}`;
  }
  if (houres === 0) {
    return `${Math.floor(minutes)}:${Math.floor(seconds)}`;
  }
  return `${Math.floor(houres)}:${Math.floor(minutes)}:${Math.floor(seconds)}`;
}

export const keysToLowerCase = (obj) => {
  var keys = Object.keys(obj);
  var n = keys.length;
  var newobj = {};
  while (n--) {
    var key = keys[n];
    if (key === "FileData") {
      var childs = Object.keys(obj[key]);
      var count = childs.length;
      var newObject = {};
      while (count--) {
        var child = childs[count];
        newObject[child[0].toLowerCase() + child.slice(1)] = obj[key][child];
      }
      newobj[key[0].toLowerCase() + key.slice(1)] = newObject;
    } else {
      newobj[key[0].toLowerCase() + key.slice(1)] = obj[key];
    }
  }
  return newobj;
};

export const ConvertToHMSWithTag = (time) => {
  const splitedTime = time.split(":");
  if (splitedTime[0] !== "00")
    return `${splitedTime[0]}h, ${splitedTime[1]}m, ${splitedTime[2]}s`;
  if (splitedTime[1] !== "00") return `${splitedTime[1]}m, ${splitedTime[2]}s`;
  return `${splitedTime[2]}s`;
};

export const FaToEnDigits = (s) =>
  s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

export function utcToTimeIran(time, format = "jYYYY/jM/jD HH:mm") {
  if (!time) {
    return null;
  }

  // Convert UTC time to Tehran time (Asia/Tehran timezone)
  const tehranTime = moment.utc(time).tz("Asia/Tehran");

  // Check if time is not "0001-01-01 00:00:00" and format accordingly
  return !moment(time).isSame("0001-01-01 00:00:00")
    ? tehranTime.format(format) // Format in Jalaali calendar
    : null;
}
